import welcome from "../imgs/welcome.png";
import blacklight from "../imgs/blacklight.png";
import nyan_cat from "../imgs/nyan-cat.gif";
function WelcomePage() {
  return (
    <div className="welcome-page">
      <div className="welcome">
        <img className="welcome-img" src={welcome}></img>
        <p className="welcome-text">
          CS1410 is an introductory course to the field of Artificial Intelligence, including knowledge representation
          and algorithms for search, optimization, planning, logical and probabilistic reasoning, and machine learning.
          We're going to teach you how to teach computers common sense! Prerequisites to CS1410 include (CSCI 0160,
          0180, 0190, or 0200) and (CSCI 0220, 1450, 0450, APMA 1650 or 1655) or minimum score of WAIVE in 'Graduate
          Student PreReq.' This course is taught by Thao Nguyen and Professor Stefanie Tellex. Students interested in
          taking CS1410 as a capstone course should email both Thao (thao_nguyen3@brown.edu) and Stefanie
          (stefanie_tellex@brown.edu).
        </p>
        <img className="welcome-nyan" src={nyan_cat}></img>
      </div>
    </div>
  );
}

export default WelcomePage;
